import { buildClasses } from "../utils/buildClasses";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { PageMeta } from "./PageMeta";
import { rawPrivacyPolicy } from "./RawPrivacyPolicy";
import styles from "./PrivacyPolicyPage.module.scss";
import { useEffect } from "react";

export function PrivacyPolicyPage() {
  // Note the block body: an expression-bodied effect would return whatever
  // window.scrollTo() evaluates to, and React treats an effect's return value as
  // its cleanup function. That threw "destroy is not a function" on unmount.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={buildClasses("website-page", "w-full", "bg-base", "isolate")}
    >
      <PageMeta
        title="Privacy Policy | Bread"
        description="How Bread collects, uses, and protects your information."
        path="/privacy"
      />
      <Header />
      <div className={styles.mainContainer}>
        <div className={styles.spacingContainer}>
          <div dangerouslySetInnerHTML={{ __html: rawPrivacyPolicy }} />
        </div>
      </div>
      <Footer />
    </div>
  );
}
